import { M36SaveClientCredentialsForm } from "@/Features";
import { styled } from "@monolith-forensics/monolith-ui";
import { useNavigate } from "react-router-dom";

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const SubTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const Description = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const M365ClientCredentialsPage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Title>Enter M365 Client Credentials</Title>
      <M36SaveClientCredentialsForm
        onCancel={() => navigate("/settings/integrations/m365")}
        onSaved={() => navigate("/settings/integrations/m365")}
      />
    </div>
  );
};
